import React from 'react'
import MenuItem from 'material-ui/MenuItem'

const buildMenuItems = (resource) => {
  return [
    <MenuItem primaryText='Edit' key='edit' value={`/ecommerce/product-categories/${resource.id}/edit`} />,
    <MenuItem primaryText='Product' key='product' value={`/ecommerce/products/${resource.product_id}/edit`} />,
    <MenuItem primaryText='Category' key='category' value={`/ecommerce/categories/${resource.category_id}/edit`} />
  ]
}

export default buildMenuItems
